import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { missionTypes } from '@/constants/missions';
import { StoreMission } from '@/types/models/mission';

import { Channel } from '../../Missions/Channel';
import { Custom } from '../../Missions/Custom';
import { Link } from '../../Missions/Link';
import { Quest } from '../../Missions/Quest';

export const All = observer<{
  missions: StoreMission[];
  onClick: (mission: StoreMission) => () => void;
}>(({ missions, onClick }) => (
  <>
    {missions.map((mission) => (
      <React.Fragment key={mission.mission.id}>
        {mission.mission.type === missionTypes.quest && (
          <Quest
            mission={mission.mission}
            completed={mission.completed}
            onClick={onClick(mission)}
          />
        )}
        {mission.mission.type === missionTypes.link && (
          <Link
            mission={mission.mission}
            completed={mission.completed}
            onClick={onClick(mission)}
          />
        )}
        {mission.mission.type === missionTypes.channel && (
          <Channel
            mission={mission.mission}
            completed={mission.completed}
            onClick={onClick(mission)}
          />
        )}
        {mission.mission.type === missionTypes.custom &&
          mission.mission.externalId !== 0 && (
            <Custom
              mission={mission.mission}
              completed={mission.completed}
              onClick={onClick(mission)}
            />
          )}
      </React.Fragment>
    ))}
  </>
));
